export enum Operation {
  BR = 'BR',
  ES = 'PE',
}
